import type { PlainButtonProps } from '@customerio/pluma-components/react';
import { Icon, PlainButton, Spinner, Tooltip, VisuallyHidden } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';
import clsx from 'clsx';
import { forwardRef } from 'react';
import * as styles from './index.css';
import { isEmptyString } from '@/utils/string';
import { useMergeRefs } from '@floating-ui/react';

/**
 * Icon Button component for the top navigation actions.
 */
export const IconButton = forwardRef<
  HTMLButtonElement,
  {
    icon: IconName;
    label: string;
    tooltip?: string;
    isLoading?: boolean;
    children?: React.ReactNode;
    className?: string;
  } & PlainButtonProps
>(function IconButton({ icon, label, tooltip, isLoading, children, className, ...rest }, ref) {
  return (
    <Tooltip content={tooltip} isDisabled={isEmptyString(tooltip)} isCustom={true}>
      {(context) => (
        <PlainButton
          ref={useMergeRefs([ref, context.reference.setReference])}
          className={clsx(styles.iconButton, className)}
          {...context.reference.getReferenceProps(rest as unknown)}
        >
          <VisuallyHidden>{label}</VisuallyHidden>

          <div className={styles.iconButtonIcon}>
            {isLoading === true ? <Spinner color="invert" /> : <Icon name={icon} size="md" sizeVersion="v2" />}
          </div>
          {children}
        </PlainButton>
      )}
    </Tooltip>
  );
});
